export const ApplyToAllModal: string = 'ApplyToAllModal';
